module.exports = __webpack_public_path__ + "img/login.a9f906c4.png";